module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "article-page"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "article-list"
  }, [_c('ul', {
    staticClass: "btn-group"
  }, [_c('li', {
    class: {
      active: _vm.show === 'hot'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.changeTopicShow('hot')
      }
    }
  }, [_vm._v("热门")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'recommend'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.changeTopicShow('recommend')
      }
    }
  }, [_vm._v("推荐")])])])]), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "showbar"
  }, [_c('div', {
    staticClass: "cover-image_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "text-shadow": "1px 1px 1px #000000"
    }
  }, [_c('h1', [_vm._v("专题")]), _vm._v(" "), _c('h3', [_vm._v("让思想汇聚，流传")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "margin-bottom": "5px"
    }
  }, [_vm._v("专题内容由多位写作者提供")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("  新建专题")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('span', {
    staticClass: "search clearfloat"
  }, [_c('span', {
    staticClass: "input"
  }, [_c('input', {
    attrs: {
      "type": "search",
      "placeholder": "搜索"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "search-icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-114f8408"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topic.vue
// module id = 59
// module chunks = 0